<template>
  <div class="icerik" style="height: calc(100vh - 0px);">
    <a class="SayfaYukle YeniBtn el-button--small el-button--success" @click="SayfaYukle">
      Rakamları Yenile</a>
    <el-row :gutter="24">
      <el-col :span="4" style="padding: 0 0 0 12px;">
        <mWidget
          :data="{isim: 'Başarılı Pos İşlem', sayi: BasariliPos+'<sup>TL</sup>', icon: 'el-icon-bank-card', renk: 'ins1 m-widget-buyuk m-widget-xl'}"></mWidget>
      </el-col>
      <el-col :span="4" style="padding: 0">
        <mWidget
          :data="{isim: 'Aidatım Pos', sayi: AidatimPos+'<sup>TL</sup>', icon: 'el-icon-bank-card', renk: 'ins2 m-widget-buyuk m-widget-xl'}"></mWidget>
      </el-col>
      <el-col :span="4" style="padding: 0">
        <mWidget
          :data="{isim: 'Pos Kar', sayi: PosKar+'<sup>TL</sup>', icon: 'el-icon-coin', renk: 'ins3 m-widget-buyuk m-widget-xl'}"></mWidget>
      </el-col>
      <el-col :span="4" style="padding: 0">
        <mWidget
          :data="{isim: 'Pos İşlem (Adet)', sayi: Islem, icon: 'el-icon-thumb', renk: 'ins4 m-widget-buyuk m-widget-xl'}"></mWidget>
      </el-col>
      <el-col :span="4" style="padding: 0">
        <mWidget
          :data="{isim: 'Sms Sarf', sayi: SmsSarf, icon: 'el-icon-chat-line-square', renk: 'ins5 m-widget-buyuk m-widget-xl'}"></mWidget>
      </el-col>
      <el-col :span="4" style="padding: 0 12px 0 0;">
        <mWidget
          :data="{isim: 'Mail Sarf', sayi: MailSarf, icon: 'el-icon-message', renk: 'ins6 m-widget-buyuk m-widget-xl'}"></mWidget>
      </el-col>
      <el-col :span="10">
        <el-tabs type="border-card" class="tabs-center tab-p0">
          <el-tab-pane :lazy=true>
            <span slot="label"><i class="el-icon-user-solid"></i> Son Kayıtlar</span>
            <AiSonKayit></AiSonKayit>
          </el-tab-pane>
          <el-tab-pane :lazy=true>
            <span slot="label"><i class="el-icon-warning"></i> Süresi Dolacaklar</span>
            <AiSuresiDolacak></AiSuresiDolacak>
          </el-tab-pane>
        </el-tabs>
      </el-col>
      <el-col :span="7">
        <el-tabs type="border-card" class="tabs-center tab-p0">
          <el-tab-pane :lazy=true>
            <span slot="label"><i class="el-icon-star-on"></i> Bugün Aidatım Pos</span>
            <AiBugunPos></AiBugunPos>
          </el-tab-pane>
          <el-tab-pane :lazy=true>
            <span slot="label"><i class="el-icon-success"></i> Bugün Başarılı Pos</span>
            <AiBugunBasariliPos></AiBugunBasariliPos>
          </el-tab-pane>
        </el-tabs>
      </el-col>
      <el-col :span="7">
        <el-tabs type="border-card" class="tabs-center tab-p0">
          <el-tab-pane :lazy=true>
            <span slot="label"><i class="el-icon-s-promotion"></i> Bugün Son 100 Sms</span>
            <AiSonSms></AiSonSms>
          </el-tab-pane>

        </el-tabs>
      </el-col>


    </el-row>
  </div>

</template>

<script>
  import mWidget from "../../components/Pack/Genel/mWidget";
  import AiSonKayit from "./comp/aiSonKayit";
  import AiBugunPos from "./comp/aiBugunPos";
  import AiBugunBasariliPos from "./comp/aiBugunBasariliPos";
  import AiSonSms from "./comp/aiSonSms";

  import AiSuresiDolacak from "./comp/aiSuresiDolacak";

  export default {
    components: {AiSuresiDolacak, AiSonSms, AiBugunBasariliPos, AiBugunPos, AiSonKayit, mWidget},
    data() {
      return {
        BasariliPos: 0,
        Islem: 0,
        AidatimPos: 0,
        PosKar: 0,
        SmsSarf: 0,
        MailSarf: 0,
      }
    },
    methods: {
      SayfaYukle() {
        this.$message.info('Rakamlar Güncelleniyor');
        this.$store.dispatch("Get", {path: '_a/p/panel'})
          .then(response => {

            if (response.Durum === 'OK') {
              var Mesaj = "";
              //if (this.BasariliPos !== response.Data.BasariliPos) Mesaj = 'Başarılı Pos' + Number(Number(response.Data.BasariliPos) - Number(this.BasariliPos)) + ' arttı';
              this.BasariliPos = response.Data.BasariliPos;
              this.Islem = response.Data.Islem;
              this.AidatimPos = response.Data.AidatimPos;
              //if (this.AidatimPos !== response.Data.AidatimPos) Mesaj ='Aidatım Pos' + (response.Data.AidatimPos - this.AidatimPos) + ' arttı');
              this.PosKar = response.Data.PosKar;
              //if (this.PosKar !== response.Data.PosKar) Mesaj = 'Aidatım Pos Karı' + Number(Number(response.Data.PosKar) - Number(this.PosKar)) + ' arttı';
              this.SmsSarf = response.Data.SmsSarf;
              this.MailSarf = response.Data.MailSarf;
              this.lo = false;
              this.$message.success('Rakamlar Güncellendi - ' + Mesaj);

              /*setTimeout(() => {
                this.SayfaYukle();
              }, 60000);
            */

            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      },
    },
    created() {
      this.SayfaYukle();

    }
  }
</script>

<style scoped>
  .SayfaYukle {
    position: absolute;
    right: 16px;
    top: 50px;
    padding: 6px 15px;
    z-index: 9;
  }

</style>



// WEBPACK FOOTER //
// src/pages/_a/Panel.vue